import React from 'react';
import ReactDOMClient from 'react-dom/client';

import App from './App';
import './index.css';


document.addEventListener("DOMContentLoaded", (event) => {
    const container = document.getElementById("root") as HTMLElement;
    const root = ReactDOMClient.createRoot(container);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
});
